import React, { useState } from "react";
import ProgressBar from './ProgressBar';
import RadioButton from '../../../UI/RadioButton';

const Slide9 = ({
  className,
  slideChange,
  validation,
  trigger,
  clearErrors,
  getValues,
  setError,
  backClick
}) => {

  const [checked1, setChecked1] = useState('');
  const [checked2, setChecked2] = useState('');

  const nextSlide = async (e) => {
    if (e.target.value == 17) {
      setChecked1('activeclass');
    } else {
      setChecked1('');
    }

    if (e.target.value == 18) {
      setChecked2('activeclass');
    } else {
      setChecked2('');
    }

    slideChange(e);
  };

  return (
    <>
      <div id="slide9" className={`col-12 top_minus ${className}`}>
        <ProgressBar value={55} />
        <h3>At the time you secured finance… </h3>

        <div className="mb-3" id="slide-F">
          <h4>Did MoneyBarn then verify those details?</h4>

          <RadioButton
            htmlFor="previously"
            value="17"
            tabIndex="2"
            id="verifyDetails-1"
            name="verifyDetails"
            className="radio-button"
            labelName="Yes"
            labelClassName={`option_but next-F ${checked1}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            htmlFor="previously"
            value="18"
            tabIndex="2"
            id="verifyDetails-2"
            name="verifyDetails"
            className="radio-button"
            labelName="No"
            labelClassName={`option_but next-F ${checked2}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <p className="text-center">
            <a href="#" className="back-E" id="back08" name="back08" onClick={backClick}>
              {'<< Previous'}
            </a>
          </p>
        </div>

      </div>
    </>
  );
};

export default Slide9;